import { CleanContent } from './ui';
import rankingImage from '../../../../assets/images/ranking-rightside.svg';

const businessModels = [
  'Supplier',
  'Trader',
  'Wholesaler',
  'Manufacturer',
  'Service Provider',
  'Farmer',
  'Transporter',
  'Homemade Product Manufacturer',
  'Miner',
  'Gems Supplier',
  'Real Estate Agent',
];

export default function Hero() {
  return (
    <CleanContent>
      <section className="bg-hero showcase-hero">
        <div className="container showcase-hero-container">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="showcase-hero-content">
                <div className="showcase-hero-copy">
                  <h1 className="h-xl mb-3 mt-5">
                    Create Your Free
                    <br />
                    <span className="showcase-hero-accent">Shop Showcase</span>
                  </h1>
                  <p className="showcase-hero-description">
                    According to your business model, whether you are a:
                  </p>
                  <ul className="showcase-business-models" aria-label="Business models">
                    {businessModels.map((businessModel) => (
                      <li className="showcase-business-model" key={businessModel}>
                        <span aria-hidden="true" />
                        {businessModel}
                      </li>
                    ))}
                  </ul>
                  <p className="showcase-hero-note">
                    <span className="showcase-hero-check" aria-hidden="true">✓</span>
                    Choose the business model that best describes your work.
                  </p>
                  <div className="showcase-hero-actions">
                    <a href="#create" className="btn btn-blue showcase-hero-button">
                      Create Your Shop Showcase
                      <i className="bi bi-arrow-right" aria-hidden="true" />
                    </a>
                    <a href="#tiers" className="btn btn-outline-primary showcase-hero-button showcase-hero-button-secondary">
                      <i className="bi bi-star-fill" aria-hidden="true" />
                      Explore 1 to 10 Star Journey
                    </a>
                  </div>
                  <p className="showcase-hero-note showcase-hero-note-trust pb-3">
                    <i className="bi bi-shield" aria-hidden="true" />
                    Your Star Rank is earned through genuine business performance, not paid placement
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-5 showcase-hero-art">
              <img src={rankingImage} alt="SELECTEZI business ranking and reputation illustration" />
            </div>
          </div>
        </div>
      </section>
    </CleanContent>
  );
}
